import { createSlice } from "@reduxjs/toolkit";


const modalCardSlice = createSlice({
    name: 'modalCard',
    initialState: {
        data: null,
        show: false,
    },
    reducers: {
        resetModalCard: (state, action) => {
            state.show = false;
            state.data = null;
        },
        showModalCard: (state, action) => {
            state.show = action.payload.show
            state.data = action.payload.data
        }

    }
})


export const { resetModalCard, showModalCard } = modalCardSlice.actions

export default modalCardSlice.reducer